import { DATA_TABLE_SCROLL } from "lib/dataTableClasses";

export default function DataTableScrollContainer({
  children,
  className = "",
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={`${DATA_TABLE_SCROLL} ${className}`.trim()}>{children}</div>
  );
}
